import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const PropertySearchInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section property-search-fin">
                <h2 className="other-pages-title">Property Search</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/property-search-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Property Search</span>
                </p>
            </div>
            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is Property Search?</h2>

                <p className="info-loan-description-smco">
                    Property search services help individuals and investors find the ideal property that matches their needs, budget, and preferences. Whether you're looking for a residential home, commercial space, or investment opportunity, our expert team provides comprehensive search assistance, market insights, and personalized recommendations. We leverage extensive databases, local knowledge, and advanced tools to identify properties that align with your goals.
                    <br /><br />
                    Our property search process involves understanding your requirements, conducting thorough market research, and presenting curated options. We consider factors such as location, price range, property type, amenities, and future potential. This service is particularly valuable in competitive markets where finding the right property quickly can make a significant difference.
                    <br /> <br />
                    Fees for property search services vary based on the complexity of the search and the value of the property. Typically, fees range from 0.5% to 2% of the property value, depending on the service level. We offer transparent pricing with no hidden costs, ensuring you get value for your investment.
                    <br /><br />
                    Choosing the right property is a major decision that can impact your lifestyle and finances. Our experienced consultants guide you through every step, from initial consultation to final selection, helping you make informed choices.
                    <br />
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features of Property Search</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Personalized search:</strong> Tailored property recommendations based on your specific needs and preferences.</li>
                        <li><strong>Market insights:</strong> Access to current market trends, pricing data, and neighborhood analysis.</li>
                        <li><strong>Exclusive listings:</strong> Access to off-market and pre-launch properties not available to the public.</li>
                        <li><strong>Virtual tours:</strong> Digital walkthroughs and 3D visualizations for remote property viewing.</li>
                        <li><strong>Negotiation support:</strong> Expert assistance in price negotiation and deal structuring.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Eligibility Criteria</h3>
                    <ul className="info-eligibility-list-smco">
                        <li><strong>Clear requirements:</strong> Defined budget, location preferences, and property type.</li>
                        <li><strong>Financial readiness:</strong> Proof of funds or financing arrangement for purchase.</li>
                        <li><strong>Legal eligibility:</strong> Compliance with local property purchase regulations.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Fees and Charges</h3>
                    <p>
                        Property search fees typically range from 0.5% to 2% of the property transaction value. Additional costs may include virtual tour fees or premium market reports.
                    </p>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits of Property Search Services</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Time-saving:</strong> Efficient search process saves you time and effort.</li>
                        <li><strong>Expert guidance:</strong> Professional advice from experienced real estate consultants.</li>
                        <li><strong>Better deals:</strong> Access to exclusive opportunities and negotiation support.</li>
                    </ul>
                </div>
            </div>
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default PropertySearchInfo;
